import { Directive, ElementRef, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormControl, FormControlDirective } from '@angular/forms'
import { fromEvent } from 'rxjs'

@Directive({
	selector: '[mosInputFocusLock]',
})
export class InputFocusLockDirective {
	element = inject(ElementRef).nativeElement as Element
	formDirective = inject(FormControlDirective)
	patchValue?: FormControl<unknown>['patchValue']
	setValue?: FormControl<unknown>['setValue']

	constructor() {
		// Unplug the form updates from the input while it's focused
		fromEvent(this.element, 'focus')
			.pipe(takeUntilDestroyed())
			.subscribe(() => {
				this.patchValue = this.formDirective.form.patchValue
				this.formDirective.form.patchValue = () => {
					/* noop */
				}
			})

		// Replug the form updates to the input when it's blurred
		fromEvent(this.element, 'blur')
			.pipe(takeUntilDestroyed())
			.subscribe(() => {
				if (!this.patchValue) return
				this.formDirective.form.patchValue = this.patchValue
				this.patchValue = undefined
			})
	}
}
